import TokenCreatedDialog from './TokenCreatedDialog';

export default TokenCreatedDialog;
